var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{style:({ marginRight: '2em' }),attrs:{"href":"javascript:cc.showSettings();","aria-label":"View cookie settings","data-cc":"c-settings"}},[_vm._v("\n  "+_vm._s(_vm.$t('settings.cookies'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }